/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SinchFaxWebhookFax } from "./SinchFaxWebhookFax";

export interface SinchFaxCompletedWebhook {
  event: string;
  fax: SinchFaxWebhookFax;
}
